import { CompositeMergeProjectCommand } from "app/ApiClient";
import { EncodingTriggeredHistoryDto } from "app/SharedApiClient";
import { LoadingState } from "types";

export interface MergeRequestCommand  {
  commandUsed: CompositeMergeProjectCommand, 
  projectId: string;   
}

export interface CompositeProjectState {
  compositeMergeHistory: EncodingTriggeredHistoryDto | null;
  compositeMergeHistoryLoading: LoadingState;
  compositeMergeErrorMessage?: string | null | undefined;
  loading: LoadingState;
  compositeMergeProgressStage?: string;
  brokenStage?: boolean; 
  mergeRequestList: Array<MergeRequestCommand>
}

export const compositProjectInitialState: CompositeProjectState = {
  loading: LoadingState.idle,
  compositeMergeHistory: null,
  compositeMergeHistoryLoading: LoadingState.idle,   
  mergeRequestList :[],
};
